<mat-form-field class="w-100">
	<mat-select
		[required]="required"
		[formControl]="fieldManager"
		[compareWith]="idComparer"
		placeholder="Field Manager"
	>
		<mat-option
			*ngFor="let fieldManager of fieldManagers$ | async"
			[value]="fieldManager"
		>
			{{ displayName(fieldManager) }}
		</mat-option>
	</mat-select>
	<mat-error>Required</mat-error>
</mat-form-field>
